const emojiQuiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "emoji-quiz",
    items: [
      { id: "q1", question: "🎤☔ ", answers: ["雨に歌えば"], image: null },
      { id: "q2", question: "🐍🐍✈️ ", answers: ["スネーク・フライト"], image: null },
      { id: "q3", question: "👻🔫 ", answers: ["ゴーストバスターズ"], image: null },
      { id: "q4", question: "🐼👊 ", answers: ["カンフーパンダ"], image: null },
      { id: "q5", question: "🏃‍♂️📦🍫 ", answers: ["フォレスト・ガンプ"], image: null },
      { id: "q6", question: "🦁👑 ", answers: ["ライオンキング"], image: null },
      { id: "q7", question: "🌊🦈 ", answers: ["ジョーズ"], image: null },
      { id: "q8", question: "🕷️👨 ", answers: ["スパイダーマン"], image: null },
      { id: "q9", question: "❄️🛳️ ", answers: ["タイタニック"], image: null },
      { id: "q10", question: "🤫🐑🐑 ", answers: ["羊たちの沈黙"], image: null },
      { id: "q11", question: "🪐🦍🦍 ", answers: ["猿の惑星"], image: null },
    ],
  },
  botId: "nualang.emoji-quiz.0.0.1",
  botName: "emoji_quiz",
  description: "emoji_quiz_desc",
  difficulty: "ALL",
  learnLang: "japanese",
  name: "ドラキュラ伯爵",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-smile?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# 映画クイズへようこそ
ドラキュラ伯爵がホストします。

絵文字で描かれた映画の名前がわかりますか？
映画のタイトルを表すものもあれば、あらすじを表すものもあります。

「こんにちは」とドラキュラ伯爵に話しかけて始めましょう。`,
  voice: "Takumi",
  versionQuestion: "このテンプレートには何問の質問が欲しいですか？",
};

export default emojiQuiz;
